'use client';

import { __makeTemplateObject, __rest, __assign } from '../_virtual/_tslib.js';
import React__default, { forwardRef, useMemo } from 'react';
import styled from 'styled-components';
import { useLayoutContext } from './LayoutContext.js';
import { MAXIMUM_COL } from './constants.js';
import { renderCssStringOfCol } from './helper.js';

var Container = styled.div(templateObject_1 || (templateObject_1 = __makeTemplateObject(["\n    ", "\n"], ["\n    ", "\n"])), function (_a) {
    var cssString = _a.cssString;
    return cssString;
});
var Col = forwardRef(function (_a, ref) {
    var _b = _a.xs, xs = _b === void 0 ? MAXIMUM_COL : _b, sm = _a.sm, md = _a.md, lg = _a.lg, xl = _a.xl, vnw = _a.vnw, children = _a.children, restProps = __rest(_a, ["xs", "sm", "md", "lg", "xl", "vnw", "children"]);
    var gutter = useLayoutContext().gutter;
    var cssString = useMemo(function () { return renderCssStringOfCol({ xs: xs, sm: sm, md: md, lg: lg, xl: xl, vnw: vnw }, gutter); }, [gutter, lg, md, sm, xl, xs, vnw]);
    return (React__default.createElement(Container, __assign({ cssString: cssString, id: 'vnwLayout__col', ref: ref }, restProps), children));
});
var templateObject_1;

export { Col as default };
//# sourceMappingURL=Col.js.map
